import { Grid, Typography, Box, Divider } from '@mui/material';
import React from 'react';
import { classes } from './utils';

const Card = () => (
  <Box className={classes.dashboardCardBox}>
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <Typography variant="body1">Total Sales</Typography>
      </Grid>
    </Grid>

    <Box className={classes.salesAmountBox} mb={1} mt={5}>
      <Typography mr={2} variant="h4">
        {' '}
        $892,280
      </Typography>
    </Box>
    <Divider variant="fullWidth" className={classes.divider} />
    <Box />

    <Box className={classes.lastMonthDetailBox}>
      <Typography mr={0.5} variant="body2">
        Last Month:
      </Typography>
      <Typography variant="body2" fontWeight={700}>
        {' '}
        $856,150
      </Typography>
    </Box>
  </Box>
);

export default Card;
